import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { AlertService } from "@app/_services";
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { OwnerStmtRezDetailService } from "../owner-stmt-rez-detail.service";
import { OwnerStmtRezDetail } from "../owner-stmt-rez-detail";
import { PropertyService } from "@app/_components/property/property.service";

@Component({
    selector: "app-owner-stmt-rez-detail",
    templateUrl: "./owner-stmt-rez-detail.component.html",
    styleUrls: ["./owner-stmt-rez-detail.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerStmtRezDetailComponent implements OnInit {
  properties: any;
  ownerStmtRezId: any;
  ownerStmtRezIdRequired: boolean;

  constructor(
    private propertyService: PropertyService,
    private primengConfig: PrimeNGConfig,
    private ownerStmtRezDetailService: OwnerStmtRezDetailService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title,
		this.ownerStmtRezId = data.ownerStmtRezId,
    this.ownerStmtRezDetail = data.ownerStmtRezDetail,
    this.statuses = ownerStmtRezDetailService.statuses;
  }

  @Input() ownerStmtRezDetail: OwnerStmtRezDetail;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  ownerStmtRezDetailId: number;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  statuses: any;

  validationMessages = {
    'ownerStmtRezDetailId': [],
    'payTo': [{ type: 'required', message: 'Please enter only numbers, characters not allowed' }],
    'title': [],
    'description': [],
    'srcStatus': [],
    'quantity': [],
    'amount': [],
    'taxAmount': [],
    'taxPct': [],
    'opsNotes': [],
    'ownerNotes': [],
    'ownerStmtRezId': [],
    'orderProductId': []
  };

  ngOnInit() {
    this.fetchProperties();
    this.primengConfig.ripple = true;
    this.formBuild();

    // if we were passed the whole ownerStmt object
    if (this.ownerStmtRezDetail) {
      this.ownerStmtRezDetailId = this.ownerStmtRezDetail.ownerStmtRezDetailId;
      this.fixDates();
      this.form1.patchValue(this.ownerStmtRezDetail);
    }
  }

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " +
        this.ownerStmtRezDetailId +
        "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.form1.value.ownerStmtRezId = this.ownerStmtRezId;

      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.ownerStmtRezDetailService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.ownerStmtRezDetail = res.data.ownerStmtRezDetail;
          this.doAdd.emit(this.ownerStmtRezDetail);
        },
        (err: any) => {
          console.log("ownerStmtRezDetail-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("ownerStmtRezDetail: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;
    //  this.form1.value.ownerStmtRezId = this.ownerStmtRezId;
      this.ownerStmtRezDetailService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.ownerStmtRezDetail = res.ownerStmtRezDetail;
          this.doUpdate.emit(this.ownerStmtRezDetail);
        },
        (err: any) => {
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.ownerStmtRezDetailService.delete(this.ownerStmtRezDetail.ownerStmtRezDetailId)
        .subscribe(
          (res: any) => {
            console.log('ownerStmtRezDetail-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.doDelete.emit(this.ownerStmtRezDetail);
          },
          (err: any) => {
            console.log('ownerStmtRezDetail-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      ownerStmtRezDetailId: [this.ownerStmtRezDetailId],
      payTo: ['', Validators.required],
      title: [],
      description: [],
      srcStatus: [],
      quantity: [],
      amount: [],
      taxAmount: [],
      taxPct: [],
      opsNotes: [],
      ownerNotes: [],
      ownerStmtRezId: [this.ownerStmtRezId],
      orderProductId: [],
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.ownerStmtRezDetail.ownerStmtRezDetailDate = moment(
      this.ownerStmtRezDetail.ownerStmtRezDetailDate
    ).toDate();
  }

  fetchProperties() {
    if (
      !this.properties ||
      this.properties === undefined ||
      this.properties.length < 1
    ) {
      try {
        this.propertyService.findAllSummary().subscribe(
          (res) => {
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.properties = res.data.properties;
            return this.properties;
          },
          (err) => {
            console.log("Feature-Update FAIL: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {}
        );
      } catch (error) {
        console.log("Form Invalid: " + JSON.stringify(error));
        this.alertService.error(error);
      }
    } else {
      // console.log('properties are ' + this.properties);
      return this.properties;
    }
  }

  selectOwnerStmtRezDetail(){
		this.ownerStmtRezIdRequired = false;
	}
}
